import firebase from "firebase";
import {ResultStatus} from "@/store/common/ResultStatus";
import ResultStatusFactory from "@/store/common/ResultStatusFactory";

export default class DatabaseConnector {

    public static isConnected:boolean = false;

    public static async connect() {
        return new Promise<ResultStatus>(async resolve => {
            firebase.initializeApp({
                apiKey: "AIzaSyBooQFzdIv4fIHZcaOP7DvUqiD_8mIZMpY",
                authDomain: "fuzukue-dev-a0b54.firebaseapp.com",
                databaseURL: "https://fuzukue-dev-a0b54.firebaseio.com",
                projectId: "fuzukue-dev-a0b54",
                storageBucket: "fuzukue-dev-a0b54.appspot.com",
                messagingSenderId: "150668476095",
                appId: "1:150668476095:web:38a1d90722d5274811500a"
            });

            // firebaseの初期化が終わらない場合対策（タイムアウト）
            setTimeout(() => {
                resolve(ResultStatusFactory.makeFailed("DB_CONNECT_001"))
            }, 60 * 1000);

            // firebaseの初期化を待つ
            await new Promise<void>(resolveAtFirebaseInit => {
                const unsubscribe = firebase.auth().onAuthStateChanged(_ => {
                    unsubscribe();
                    resolveAtFirebaseInit();
                });
            });

            resolve(ResultStatusFactory.makeSuccess());
        });
    }
}
